<template>
    <div>
        <zm-button type="primary" plain @click="showCreate" v-if="hasPermission">Create</zm-button>
        <zm-table :data="list" v-loading="loading">
            <zm-table-column label="Name" prop="name"></zm-table-column>
            <zm-table-column label="Metrics Name" prop="metricName"></zm-table-column>
            <zm-table-column label="Tags" prop="tagRules">
                <template slot-scope="scope">
                    <zm-tag size="mini" v-for="(i, index) in scope.row.tagRules" :key="index">{{ i.name }}{{ i.operator }}{{ i.value }}</zm-tag>
                </template>
            </zm-table-column>
            <zm-table-column label="Trigger Rules" prop="triggerRules" width="160px">
                <template slot-scope="scope">
                    <zm-popover placement="bottom" v-for="item in scope.row.triggerRules" :key="item.id">
                        <div>
                            <span v-for="(i, index) in item.items" :key="index">
                                <p>{{ i.name }}{{ i.operator }}{{ i.value }}</p>
                            </span>
                        </div>
                        <zm-tag size="mini" slot="reference">{{ item.level }}</zm-tag>
                    </zm-popover>
                </template>
            </zm-table-column>
            <zm-table-column label="Enable" prop="enable" width="90px">
                <template slot-scope="scope">
                    <i :class="scope.row.enable ? 'zm-icon-ok' : 'zm-icon-close'"></i>
                </template>
            </zm-table-column>
            <zm-table-column width="160px" v-if="hasPermission">
                <template slot-scope="scope">
                    <zm-button type="icon" class="zm-icon-edit" @click="showEdit(scope.row)"></zm-button>
                    <zm-button size="small" class="btn-contain" type="icon" title="change status" :icon="scope.row.enable ? 'zm-icon-pause' : 'zm-icon-play'"
                    @click="changeStatus(scope.row)"></zm-button>
                    <zm-button type="icon" class="zm-icon-delete" @click="showDelete(scope.row.id)"></zm-button>
                </template>
            </zm-table-column>
        </zm-table>
        <div style="text-align: center" class="pagination-wrap">
            <zm-pagination @current-change="fetchData"
                @size-change="handleSizeChange"
                :current-page.sync="pageable.page" :page-size="pageable.size"
                layout="total, prev, pager, next, sizes"
                :page-sizes="[10, 20, 50, 100, 500, 1000]"
                :total="pageable.total">
            </zm-pagination>
        </div>
        <zm-dialog :visible.sync="visible" :title="form.title" width="80%">
            <zm-form label-width="150px" label-position="left" :model="form" ref="form" :rules="rules">
                <zm-form-item prop="name">
                    <div slot="label">
                        <tip label="Name" id="alarmrule-name"></tip>
                    </div>
                    <zm-input v-model.trim="form.name" size="small"></zm-input>
                </zm-form-item>
                <zm-form-item label="description">
                    <div slot="label">
                        <tip label="Description" id="alarmrule-description"></tip>
                    </div>
                    <zm-input type="textarea" v-model="form.description" size="small"></zm-input>
                </zm-form-item>
                <zm-form-item prop="notificationRuleIds">
                    <div slot="label">
                        <tip label="NotificationRules" id="alarmrule-notificationRuleIds"></tip>
                    </div>
                    <zm-select v-model="form.notificationRuleIds" multiple filterable size="small" style="width: 100%">
                    <zm-option v-for="item in notificationRuleList" :key="item.id" :label="item.name"
                    :value="item.id"></zm-option>
                    </zm-select>
                </zm-form-item>
                <zm-form-item prop="metricName">
                    <div slot="label">
                        <tip label="metricName" id="alarmrule-metricName"></tip>
                    </div>
                    <zm-select v-model="form.metricName" size="small" style="width: 100%" @change="fetchTags">
                        <zm-option v-for="item in metricsList" :key="item" :label="item" :value="item"></zm-option>
                    </zm-select>
                </zm-form-item>
                <zm-form-item prop="Tags">
                    <div slot="label">
                        <tip label="Tags" id="alarmrule-tags"></tip>
                    </div>
                    <zm-button size="small" @click="addParam" type="icon" icon="zm-icon-add" :disabled="addDisabled">add parameter</zm-button>
                    <zm-table :data="tagTable" max-height="300">
                        <zm-table-column prop="name" label="name">
                            <template slot-scope="scope">
                                <span v-if="!scope.row.isEdit">{{ scope.row.name }}</span>
                                <zm-select size="small" v-model="scope.row.name" v-else filterable clearable @change="fetchTagValue" allow-create>
                                    <zm-option v-for="item in selectableKeys" :key="item.name"
                                        :value="item.name" :label="item.name"></zm-option>
                                </zm-select>
                            </template>
                        </zm-table-column>
                        <zm-table-column prop="operator" label="operator">
                            <template slot-scope="scope">
                                <span v-if="!scope.row.isEdit">{{ scope.row.operator }}</span>
                                <zm-select size="small" v-model="scope.row.operator" v-else>
                                    <zm-option label="==" value="=="></zm-option>
                                    <zm-option label="!=" value="!="></zm-option>
                                </zm-select>
                            </template>
                        </zm-table-column>
                        <zm-table-column prop="value" label="value">
                            <template slot-scope="scope">
                                <span v-if="!scope.row.isEdit">{{ scope.row.value }}</span>
                                <zm-select size="small" v-model="scope.row.value" v-else @focus="fetchTagValue(scope.row.name)"
                                filterable clearable allow-create>
                                    <zm-option v-for="item in valueList" :key="item"
                                        :value="item" :label="item"></zm-option>
                                </zm-select>
                                <!-- <zm-input size="small" v-model.trim="scope.row.value" v-else></zm-input> -->
                            </template>
                        </zm-table-column>
                        <zm-table-column width="100px">
                            <!-- eslint-disable-next-line -->
                            <template slot="header" slot-scope="scope">
                                <zm-button size="small" @click="addParam" type="icon" icon="zm-icon-add" :disabled="addDisabled">add parameter</zm-button>
                            </template>
                            <template slot-scope="scope">
                                <zm-button size="small" type="icon" icon="zm-icon-edit" @click="scope.row.isEdit = true" v-if="!scope.row.isEdit"></zm-button>
                                <zm-button size="small" type="icon" icon="zm-icon-ok" v-else
                                    @click="scope.row.isEdit = false" :disabled="!scope.row.value.length || !scope.row.name.length"></zm-button>
                                <zm-button size="small" type="icon" icon="zm-icon-delete" @click="deleteParam(scope.row)"></zm-button>
                            </template>
                        </zm-table-column>
                    </zm-table>
                </zm-form-item>
                <zm-form-item prop="TriggerRules">
                    <div slot="label">
                        <tip label="TriggerRules" id="alarmrule-triggerRules"></tip>
                        <zm-button @click="addRule" type="text" icon="zm-icon-add">add rule</zm-button>
                    </div>
                    <rule :ref="'rule-' + index" :index="index"
                    @deleteRule="deleteRule()"
                    v-for="(item, index) in form.triggerRules" :key="index"
                    :metricName="form.metricName" :data="item"></rule>
                </zm-form-item>
                <zm-form-item label-width="0">
                    <zm-checkbox v-model="form.enable" size="small">
                        <tip label="enable" id="alarmrule-enable"></tip>
                    </zm-checkbox>
                </zm-form-item>
            </zm-form>
            <div slot="footer" class="dialog-footer">
                <zm-button size="small" @click="visible = false">Cancel</zm-button>
                <zm-button size="small" type="primary" @click="save" :loading="loading">Save</zm-button>
            </div>
        </zm-dialog>
    </div>
</template>
<script>
import {
    createAlarmRule,
    deleteAlarmRule,
    listAlarmRule,
    listAllNotificationRule,
    listMetrics,
    listTags,
    listTagValues,
    updateAlarmRule,
    updateAlarmRuleStatus
} from '@/api/monitorManager'
import tip from 'components/ToolTip/index'
import rule from './rule'
export default {
    name: 'alarmRule',
    components: { tip, rule },
    data () {
        return {
            hasPermission: localStorage.role === 'SUPER_ADMIN' || localStorage.role === 'ADMIN',
            list: [],
            loading: false,
            visible: false,
            metricsList: [],
            tagList: [],
            valueList: [],
            notificationRuleList: [],
            typeList: ['IM', 'Webhook', 'Email', 'Incident'],
            form: {
                title: '',
                id: '',
                name: '',
                metricName: '',
                notificationRuleIds: [],
                description: '',
                tagRules: [],
                triggerRules: [],
                enable: false
            },
            tagTable: [],
            pageable: {
                page: 1,
                size: 10,
                total: 0
            },
            rules: {
                name: [
                    { required: true, message: 'please select name', trigger: 'blur' }
                ],
                metricName: [
                    { required: true, message: 'please select metricName', trigger: 'blur' }
                ]
            }
        }
    },
    computed: {
        selectableKeys () {
            let data = this.tagList
            this.tagList.map(key => {
                key.active = true
                this.tagTable.map(item => {
                    if (key.name === item.name) {
                        key.active = false
                    }
                })
            })
            return data
        },
        addDisabled () {
            let data = false
            this.tagTable.map(item => {
                if (item.isEdit) {
                    data = true
                }
            })
            return data
        }
    },
    created () {
        this.fetchData()
        this.fetchMetrics()
        this.fetchNotificationRule()
    },
    methods: {
        handleSizeChange (val) {
            this.pageable.size = val
            this.fetchData()
        },
        addRule () {
            this.form.triggerRules.push({
                id: '',
                items: [{
                    name: '',
                    operator: '==',
                    value: ''
                }],
                lastCount: 3,
                lastTime: 600,
                level: 'WARN',
                timeUnit: 'SECONDS'
            })
        },
        deleteRule (val) {
            if (this.form.triggerRules.length > 1) {
                this.form.triggerRules.map((item, index) => {
                    item.id = this.$refs['rule-' + index][0].form.id
                    item.lastCount = this.$refs['rule-' + index][0].form.lastCount
                    item.lastTime = this.$refs['rule-' + index][0].form.lastTime
                    item.level = this.$refs['rule-' + index][0].form.level
                    item.timeUnit = this.$refs['rule-' + index][0].form.timeUnit
                    item.items = this.$refs['rule-' + index][0].form.items
                })
                this.form.triggerRules.splice(val, 1)
                this.form.triggerRules.map((item, index) => {
                    this.$refs['rule-' + index][0].form.id = item.id
                    this.$refs['rule-' + index][0].form.lastCount = item.lastCount
                    this.$refs['rule-' + index][0].form.lastTime = item.lastTime
                    this.$refs['rule-' + index][0].form.level = item.level
                    this.$refs['rule-' + index][0].form.timeUnit = item.timeUnit
                    this.$refs['rule-' + index][0].form.items = item.items
                })
            } else {
                this.form.triggerRules[0].id = ''
                this.form.triggerRules[0].lastCount = ''
                this.form.triggerRules[0].lastTime = ''
                this.form.triggerRules[0].level = ''
                this.form.triggerRules[0].timeUnit = ''
                this.form.triggerRules[0].items = []
                this.$refs['rule-0'][0].form.id = ''
                this.$refs['rule-0'][0].form.lastCount = ''
                this.$refs['rule-0'][0].form.lastTime = ''
                this.$refs['rule-0'][0].form.level = ''
                this.$refs['rule-0'][0].form.timeUnit = ''
                this.$refs['rule-0'][0].form.items = []
                this.$message.warning('Please input items')
            }
        },
        save () {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.form.tagRules = []
                    this.tagTable.map(item => {
                        this.form.tagRules.push(item)
                    })
                    this.form.triggerRules.map((item, index) => {
                        // item.id = this.$refs['rule-' + index][index].form.id
                        item.lastCount = this.$refs['rule-' + index][0].form.lastCount
                        item.lastTime = this.$refs['rule-' + index][0].form.lastTime
                        item.level = this.$refs['rule-' + index][0].form.level
                        item.timeUnit = this.$refs['rule-' + index][0].form.timeUnit
                        item.items = this.$refs['rule-' + index][0].form.items
                    })
                    const { title, id, name, metricName, notificationRuleIds, description, enable, tagRules, triggerRules } = this.form
                    const data = { name, metricName, notificationRuleIds, description, enable, tagRules, triggerRules }
                    if (title === 'Create Alarm Rule') {
                        this.loading = true
                        createAlarmRule(data).then(response => {
                            this.$message.success('Create success')
                            this.loading = false
                            this.visible = false
                            this.fetchData()
                        }).catch(() => {
                            this.loading = false
                        })
                    } else if (title === 'Edit Alarm Rule') {
                        this.loading = true
                        updateAlarmRule(id, data).then(response => {
                            this.$message.success('Update success')
                            this.loading = false
                            this.visible = false
                            this.fetchData()
                        }).catch(() => {
                            this.loading = false
                        })
                    }
                }
            })
        },
        showCreate () {
            this.form.title = 'Create Alarm Rule'
            this.form.id = ''
            this.form.name = ''
            this.form.metricName = ''
            this.form.description = ''
            this.form.notificationRuleIds = []
            this.form.tagRules = []
            this.form.triggerRules = []
            this.form.enable = false
            this.visible = true
        },
        showEdit (row) {
            this.form.title = 'Edit Alarm Rule'
            this.form.id = row.id
            this.form.name = row.name
            this.form.metricName = row.metricName
            this.fetchTags()
            this.form.notificationRuleIds = row.notificationRuleIds
            this.form.tagRules = JSON.parse(JSON.stringify(row.tagRules))
            this.tagTable = []
            if (row.tagRules) {
                row.tagRules.map(item => {
                    this.tagTable.push({
                        name: item.name,
                        operator: item.operator,
                        value: item.value,
                        isEdit: false
                    })
                })
            }
            this.form.triggerRules = JSON.parse(JSON.stringify(row.triggerRules))
            this.form.description = row.description
            this.form.enable = row.enable
            this.visible = true
        },
        changeStatus (row) {
            this.$confirm('This will change the status. Continue?', 'Warning', {
                confirmButtonText: 'Change',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                const data = {
                    active: !row.enable
                }
                this.loading = true
                updateAlarmRuleStatus(row.id, data).then(response => {
                    this.loading = false
                    this.fetchData()
                    this.$message.success('Change status success!')
                }).catch(() => {
                    this.loading = false
                })
            }).catch(() => {
                this.$message.info('Change canceled')
            })
        },
        showDelete (id) {
            this.$confirm('This will delete the alarm rule. Continue?', 'Warning', {
                confirmButtonText: 'Delete',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                deleteAlarmRule(id).then(response => {
                    this.loading = false
                    this.$message.success('Delete success!')
                    this.fetchData()
                }).catch(() => {
                    this.loading = false
                })
            }).catch(() => {
                this.loading = false
                this.$message.info('Delete canceled')
            })
        },
        fetchData () {
            this.loading = true
            listAlarmRule(this.pageable.size, this.pageable.page - 1).then(response => {
                const { content, pageable: { page, size }, total } = response
                this.list = content
                this.pageable.total = total
                this.pageable.page = page + 1
                this.pageable.size = size
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        fetchMetrics () {
            if (!this.metricsList.length) {
                listMetrics().then(response => {
                    this.metricsList = response
                })
            }
        },
        fetchNotificationRule () {
            if (!this.notificationRuleList.length) {
                listAllNotificationRule().then(response => {
                    this.notificationRuleList = response
                })
            }
        },
        fetchTags () {
            listTags(this.form.metricName).then(response => {
                this.tagList = response.map(i => {
                    return {
                        name: i,
                        active: true
                    }
                })
            })
        },
        fetchTagValue (val) {
            if (this.form.metricName && val) {
                listTagValues(this.form.metricName, val).then(response => {
                    this.valueList = response
                })
            } else {
                this.valueList = []
            }
        },
        addParam () {
            this.tagTable.unshift({
                name: '',
                operator: '==',
                value: '',
                isEdit: true
            })
        },
        deleteParam (row) {
            if (row.name) {
                this.tagTable.map((item, index, arr) => {
                    if (item.name === row.name && item.operator === row.operator && item.value === row.value) {
                        this.tagTable.splice(index, 1)
                    }
                })
            } else {
                this.tagTable.shift()
            }
        }
    }
}
</script>
<style>
.number-with-select .zm-input__inner {
    border-radius: 8px 0 0 8px;
}
.select-with-number {
    width: 110px;
}
.select-with-number .zm-select-input {
    border-radius: 0 8px 8px 0;
}
.select-with-number.zm-select {
    border-radius: 0 8px 8px 0;
}
</style>
